import { render, staticRenderFns } from "./edit-confirm-methods.vue?vue&type=template&id=2697d0c2"
import script from "./edit-confirm-methods.vue?vue&type=script&lang=ts"
export * from "./edit-confirm-methods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2697d0c2')) {
      api.createRecord('2697d0c2', component.options)
    } else {
      api.reload('2697d0c2', component.options)
    }
    module.hot.accept("./edit-confirm-methods.vue?vue&type=template&id=2697d0c2", function () {
      api.rerender('2697d0c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/edit-confirm-methods.vue"
export default component.exports